import './Navbar.scss';
import { faHistory, faChartLine, faCogs, faBell, faDashboard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PexipInstance } from '../../models/PexipInstance';

export default function Navbar({ pexipInstances }: any) {
  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();
  const [instanceId, setInstanceId] = useState(pexipInstances && pexipInstances.length > 0 ? pexipInstances[0]._id : '');

  useEffect(() => {
    const pathnameArray = location.pathname.split('/');
    if (pathnameArray.length > 2 && pathnameArray[1] === 'instance') {
      setInstanceId(pathnameArray[2]);
    }
  }, [location, navigate]);

  function handleChange(value: string) {
    const pathnameArray = location.pathname.split('/');
    pathnameArray[2] = value;
    setInstanceId(value);
    if (pathnameArray[1] !== 'global') {
      navigate(pathnameArray.join('/'));
    }
  }

  return (
    <div className="navbar">
      <div className="nav">
        {/* <NavLink
          to="/global"
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faDashboard} />
          {t('Navbar.global')}
        </NavLink> */}
        <NavLink
          to={`/instance/${instanceId}/overview`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faDashboard} />
          {t('Navbar.overview')}
        </NavLink>

        <NavLink
          to={`/instance/${instanceId}/real-time`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faHistory} />
          {t('Navbar.realTime')}
        </NavLink>

        <NavLink
          to={`/instance/${instanceId}/real-time-statistics`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faChartLine} />
          {t('Navbar.liveStatistics')}
        </NavLink>

        <NavLink
          to={`/instance/${instanceId}/configuration`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faCogs} />
          {t('Navbar.nodesConfiguration')}
        </NavLink>

        {/* //TODO: reenable this link if we need global list with interractions of all participants in a pexip instance  */}
        {/* <NavLink
          to={`/instance/${instanceId}/participants`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faUsers} />
          {t('Navbar.participants')}
        </NavLink> */}

        <NavLink
          to={`/instance/${instanceId}/alarms`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faBell} />
          {t('Navbar.alarms')}
        </NavLink>

        <NavLink
          to={`/instance/${instanceId}/history`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faHistory} />
          {t('Navbar.historics')}
        </NavLink>

        <NavLink
          to={`/instance/${instanceId}/history-statistics`}
          className={({ isActive }) => (isActive ? 'active-tab nav-item pointer' : 'nav-item pointer')}
        >
          <FontAwesomeIcon className="nav-icon" icon={faChartLine} />
          {t('Navbar.historyStatistics')}
        </NavLink>

      </div>

      <div className="dropdown">
        <select
          name="select-infra"
          id="select-infra"
          value={instanceId}
          onChange={(event) => handleChange(event.target.value)}
        >
          {pexipInstances.map((instance: PexipInstance) => (
            <option key={instance._id} value={instance._id}>
              {instance.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
